export const LOGGED_IN_USER_INFO = 'loggedInUserInfo';
export const LOGIN_ENDPOINT = '/login';
export const ACCESS_TOKEN_ENDPOINT = '/refresh';
export const FORM_ACTION_TYPE = 'form_submit';
